import { subscribe } from '../../../common/errors/sagas';
import { notificationError } from '../../../common/errors/notificationTypes';
import { subscribeConfiguration } from '../../../common/saveconfiguration/sagas';

const pre = 'IMPACTANALYSIS/IMPACTSUMMARY/';

export const CSV_EXPORT_EMPTY = `${pre}CSV_EXPORT_EMPTY`;
export const IM_IMPACT_SUMMARY_LOADED = `${pre}IM_IMPACT_SUMMARY_LOADED`;
export const SET_IMPACT_SUMMARY_COLUMNS = `${pre}SET_IMPACT_SUMMARY_COLUMNS`;
export const SET_IMPACT_SUMMARY_ROWS = `${pre}SET_IMPACT_SUMMARY_ROWS`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_IMPACT_SUMMARY_LOADED = `${pre}SET_IMPACT_SUMMARY_LOADED`;
export const COMPARE_CSAS_REQUEST = `${pre}COMPARE_CSAS_REQUEST`;
export const COMPARE_CSAS_REQUEST_FAILED = `${pre}COMPARE_CSAS_REQUEST_FAILED`;
export const SET_DEFAULT_CONFIG = `${pre}SET_DEFAULT_CONFIG`;
export const INITIALISE = `${pre}INITIALISE`;
export const SET_INITIALISE = `${pre}SET_INITIALISE`;
export const SET_SAVED_FILTERS = `${pre}SET_SAVED_FILTERS`;
export const SET_SHOW_ALL_ROWS = `${pre}SET_SHOW_ALL_ROWS`;
export const EXPAND_ROWS = `${pre}EXPAND_ROWS`;

subscribe(CSV_EXPORT_EMPTY, 'Failed to export as CSV - no data', notificationError);
subscribe(COMPARE_CSAS_REQUEST_FAILED, 'Error loading new data for the page', notificationError);
subscribeConfiguration(SET_IMPACT_SUMMARY_COLUMNS, 'ImpactAnalysis');

export const initialise = () => ({
    type: INITIALISE
});

export const setInitialise = () => ({
    type: SET_INITIALISE
});

export const setDefaultConfig = columns => ({
    type: SET_DEFAULT_CONFIG,
    columns
});

export const compareCsasRequest = data => ({
    type: COMPARE_CSAS_REQUEST,
    data
});

export const setImpactSummaryLoaded = loaded => ({
    type: SET_IMPACT_SUMMARY_LOADED,
    loaded
});

export const compareCsasRequestFailed = error => ({
    type: COMPARE_CSAS_REQUEST_FAILED,
    error
});

export const csvExportEmpty = error => ({
    type: CSV_EXPORT_EMPTY,
    error
});

export const imImpactSummaryLoaded = () => ({
    type: IM_IMPACT_SUMMARY_LOADED
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const setImpactSummaryColumns = data => ({
    type: SET_IMPACT_SUMMARY_COLUMNS,
    data
});

export const setImpactSummaryRows = data => ({
    type: SET_IMPACT_SUMMARY_ROWS,
    data
});

export const setSavedFilters = (counterparties, csas) => ({
    type: SET_SAVED_FILTERS,
    counterparties,
    csas
});

export const setShowAllRows = checked => ({
    type: SET_SHOW_ALL_ROWS,
    checked
});

export const expandRows = id => ({
    type: EXPAND_ROWS,
    id
});
